import { render, staticRenderFns } from "./beast_info.vue?vue&type=template&id=fd264ce4&"
import script from "./beast_info.vue?vue&type=script&lang=js&"
export * from "./beast_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports